import { render, staticRenderFns } from "./OmniviewHeader.vue?vue&type=template&id=5620538a&scoped=true&"
import script from "./OmniviewHeader.vue?vue&type=script&lang=js&"
export * from "./OmniviewHeader.vue?vue&type=script&lang=js&"
import style0 from "./OmniviewHeader.vue?vue&type=style&index=0&id=5620538a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5620538a",
  null
  
)

export default component.exports